// extracted by mini-css-extract-plugin
module.exports = {"ButtonStylePrimary":"ButtonComponent-module--ButtonStylePrimary--1Tx_K","ButtonStyleSecondary":"ButtonComponent-module--ButtonStyleSecondary--2oHQi"};